import { Link } from "react-router-dom";

const entries = [
  {
    to: "/category/movie",
    icon: "ri-film-line",
    label: "电影",
    desc: "院线佳片、高分佳作，类型丰富随心看",
    tone: "bg-primary-100 text-primary-700",
    hover: "hover:border-primary-300",
  },
  {
    to: "/category/tv",
    icon: "ri-tv-2-line",
    label: "电视剧",
    desc: "热播剧集、经典好剧，追剧不停更",
    tone: "bg-accent-100 text-accent-700",
    hover: "hover:border-accent-300",
  },
  {
    to: "/category/variety",
    icon: "ri-mic-line",
    label: "综艺",
    desc: "音乐、美食、真人秀，快乐不间断",
    tone: "bg-secondary-100 text-secondary-700",
    hover: "hover:border-secondary-300",
  },
];

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {entries.map((entry) => (
        <Link
          key={entry.to}
          to={entry.to}
          className={`group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-all duration-300 hover:-translate-y-1 ${entry.hover}`}
        >
          <span className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-lg ${entry.tone}`}>
            <i className={`${entry.icon} text-2xl`} />
          </span>
          <div className="min-w-0 flex-1">
            <h3 className="font-heading text-lg font-bold text-foreground-950">{entry.label}</h3>
            <p className="mt-1 line-clamp-1 text-sm text-foreground-500">{entry.desc}</p>
          </div>
          <i className="ri-arrow-right-line text-xl text-foreground-300 transition-transform group-hover:translate-x-1 group-hover:text-primary-500" />
        </Link>
      ))}
    </div>
  );
}